/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Connection } from './Connection';
import {
    ConnectionFromJSON,
    ConnectionFromJSONTyped,
    ConnectionToJSON,
} from './Connection';

/**
 * 
 * @export
 * @interface CustomAuthConnectResponseOneOf1
 */
export interface CustomAuthConnectResponseOneOf1 {
    /**
     * 
     * @type {Connection}
     * @memberof CustomAuthConnectResponseOneOf1
     */
    connection: Connection;
}

/**
 * Check if a given object implements the CustomAuthConnectResponseOneOf1 interface.
 */
export function instanceOfCustomAuthConnectResponseOneOf1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "connection" in value;

    return isInstance;
}

export function CustomAuthConnectResponseOneOf1FromJSON(json: any): CustomAuthConnectResponseOneOf1 {
    return CustomAuthConnectResponseOneOf1FromJSONTyped(json, false);
}

export function CustomAuthConnectResponseOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthConnectResponseOneOf1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'connection': ConnectionFromJSON(json['connection']),
    };
}

export function CustomAuthConnectResponseOneOf1ToJSON(value?: CustomAuthConnectResponseOneOf1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'connection': ConnectionToJSON(value.connection),
    };
}

